<template>
  <div id="staff-create-premium">
    <v-card class="premium-modal-card overflow-hidden shadow-mega"
      style="border-radius: 32px !important; background: #ffffff !important;">
      <!-- JCI Approved Gradient Header (LDMT Style) -->
      <v-card-title class="pa-0">
        <v-sheet class="modal-header-banner d-flex align-center px-10" height="140" width="100%"
          style="background: linear-gradient(135deg, #3A67B1 0%, #0097D7 100%) !important; position: relative !important; overflow: hidden !important;"
          dark>
          <!-- Animated Pattern Background -->
          <div class="header-pattern-overlay"></div>

          <div class="header-content d-flex align-center" style="position: relative; z-index: 2;">
            <v-avatar color="rgba(255,255,255,0.2)" size="70" class="mr-6 elevation-6 profile-ring-lite">
              <v-icon size="36" color="white">mdi-account-plus</v-icon>
            </v-avatar>
            <div>
              <div class="text-overline white--text opacity-70" style="letter-spacing: 3px !important; line-height: 1">
                ADMINISTRATION</div>
              <h2 class="text-h3 font-weight-black white--text" style="letter-spacing: -0.5px !important;">New Staff
                Personnel</h2>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="closePrompt" class="modal-close-btn"
            style="background: rgba(255, 255, 255, 0.1) !important; position: relative; z-index: 10;">
            <v-icon color="white" size="28">mdi-close</v-icon>
          </v-btn>
        </v-sheet>
      </v-card-title>

      <v-form ref="form1" v-model="valid1" lazy-validation class="pa-10">
        <v-card-text class="pa-0">
          <!-- Identification Group -->
          <div class="d-flex align-center mb-8">
            <v-sheet color="#f0f7ff" class="pa-2 rounded-lg mr-4">
              <v-icon style="color: #3A67B1 !important;">mdi-account-box</v-icon>
            </v-sheet>
            <span class="text-h5 font-weight-black" style="color: #0A0F29 !important;">Personal Identification</span>
            <v-divider class="ml-6" style="opacity: 0.1"></v-divider>
          </div>

          <v-row>
            <v-col cols="12" sm="6">
              <div class="input-label mb-2 ml-1"
                style="color: #414042 !important; font-size: 0.85rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px;">
                First Name <span class="error--text">*</span></div>
              <v-text-field v-model="FirstName" :rules="FirstNameRules" placeholder="Required" required outlined rounded
                dense class="premium-form-input-field" prepend-inner-icon="mdi-account"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="input-label mb-2 ml-1"
                style="color: #414042 !important; font-size: 0.85rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px;">
                Last Name <span class="error--text">*</span></div>
              <v-text-field v-model="LastName" :rules="LastNameRules" placeholder="Required" required outlined rounded
                dense class="premium-form-input-field" prepend-inner-icon="mdi-account-outline"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="input-label mb-2 ml-1"
                style="color: #414042 !important; font-size: 0.85rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px;">
                Primary Contact <span class="error--text">*</span></div>
              <v-text-field v-model="MobileNo" :rules="MobileNoRules" placeholder="10-digit mobile number" type="number"
                required outlined rounded dense class="premium-form-input-field"
                prepend-inner-icon="mdi-phone"></v-text-field>
            </v-col>
          </v-row>

          <!-- Assignment Group -->
          <div class="d-flex align-center mt-10 mb-8">
            <v-sheet color="#ecfdf5" class="pa-2 rounded-lg mr-4">
              <v-icon style="color: #56BDA3 !important;">mdi-briefcase</v-icon>
            </v-sheet>
            <span class="text-h5 font-weight-black" style="color: #0A0F29 !important;">Professional Assignment</span>
            <v-divider class="ml-6" style="opacity: 0.1"></v-divider>
          </div>

          <v-row>
            <v-col cols="12" sm="6">
              <div class="input-label mb-2 ml-1"
                style="color: #414042 !important; font-size: 0.85rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px;">
                Official Designation <span class="error--text">*</span></div>
              <v-text-field v-model="Designation" :rules="DesignationRules" placeholder="e.g. Senior Executive" required
                outlined rounded dense class="premium-form-input-field"
                prepend-inner-icon="mdi-badge-account-horizontal"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="input-label mb-2 ml-1"
                style="color: #414042 !important; font-size: 0.85rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px;">
                Sequence Order <span class="error--text">*</span></div>
              <v-text-field v-model="OrderBy" :rules="OrderByRules" type="number" placeholder="0" required outlined
                rounded dense class="premium-form-input-field"
                prepend-inner-icon="mdi-sort-numeric-ascending"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="input-label mb-2 ml-1"
                style="color: #414042 !important; font-size: 0.85rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px;">
                NHQ Email Identity <span class="error--text">*</span></div>
              <v-text-field v-model="EmailId" :rules="EmailIdRules" placeholder="username@jciindia.in" type="text"
                required outlined rounded dense class="premium-form-input-field"
                prepend-inner-icon="mdi-email-check-outline"></v-text-field>
            </v-col>
          </v-row>

          <v-alert v-if="!valid1" dense text type="error" class="mt-8 rounded-2xl font-weight-bold elevation-2"
            icon="mdi-alert-octagon"
            style="background-color: #fff1f2 !important; color: #e11d48 !important; border: 1px solid #fda4af !important;">
            Some required information is missing. Please review the highlighted fields.
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-0 mt-12">
          <v-spacer></v-spacer>
          <v-btn @click="closePrompt" text class="px-10 font-weight-black"
            style="color: #414042 !important; text-transform: none; letter-spacing: 1px; height: 56px !important;">
            Discard
          </v-btn>
          <v-btn :disabled="!valid1" @click.prevent="confirmAlert" :loading="SubmitFlag" dark rounded elevation="12"
            class="px-12 font-weight-black ml-6 save-btn-pulse"
            style="background: linear-gradient(135deg, #3A67B1 0%, #0097D7 100%) !important; text-transform: none; letter-spacing: 1.5px; height: 56px !important;">
            <v-icon left size="24">mdi-check-decagram</v-icon>
            FINALIZE & SAVE
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      rows: [],

      FirstName: "",
      FirstNameRules: [(v) => !!v || "First Name is required"],

      LastName: "",
      LastNameRules: [(v) => !!v || "Last Name is required"],

      MobileNo: "",
      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailId: "",
      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      Designation: "",
      DesignationRules: [(v) => !!v || "Designation is required"],

      OrderBy: 0,
      OrderByRules: [(v) => !!v || "Order By is required"],
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      //   this.$refs.ProfilePicture.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt");
    },
    refreshPageData() {
      console.log("refreshPageData called");
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "Confirming personnel registration.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, Register`,
          confirmButtonColor: "#3A67B1",
          cancelButtonText: `Review Again`,
          cancelButtonColor: "#414042",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "Process paused", true);
          }
        });
      } else {
        this.toast("error", "Kindly complete mandatory fields", true);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/staff-create";
        var upload = {
          FirstName: this.FirstName,
          LastName: this.LastName,
          MobileNo: this.MobileNo,
          EmailId: this.EmailId,
          Designation: this.Designation,
          OrderBy: this.OrderBy,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.resetForm();
              thisIns.closePrompt();
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        thisIns.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style>
/* Mega shadow and animations for modal */
.shadow-mega {
  box-shadow: 0 35px 80px rgba(58, 103, 177, 0.3) !important;
}

#staff-create-premium .header-pattern-overlay {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.08) 1px, transparent 0) !important;
  background-size: 30px 30px !important;
  z-index: 1;
}

#staff-create-premium .modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: rotate(180deg) scale(1.1) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

#staff-create-premium .premium-form-input-field .v-input__control .v-input__slot {
  background: #f8fafc !important;
  border: 2px solid #e2e8f0 !important;
  transition: all 0.3s ease !important;
  padding: 8px 16px !important;
}

#staff-create-premium .premium-form-input-field .v-input__control .v-input__slot:hover {
  border-color: #3A67B1 !important;
  background: #ffffff !important;
}

#staff-create-premium .premium-form-input-field.v-input--is-focused .v-input__slot {
  border-color: #3A67B1 !important;
  box-shadow: 0 0 0 5px rgba(58, 103, 177, 0.12) !important;
  background: #ffffff !important;
}

#staff-create-premium .save-btn-pulse:hover {
  transform: translateY(-3px) scale(1.02);
  filter: brightness(1.1);
  box-shadow: 0 15px 35px rgba(58, 103, 177, 0.4) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

#staff-create-premium .profile-ring-lite {
  border: 3px solid rgba(255, 255, 255, 0.4) !important;
}
</style>
